import React, {Fragment, useState} from 'react';
import {observer} from "mobx-react";
import HeightPin from "./HeightPin";
import GemDiscover from "./elements/GemDiscover";
import StarPicker from "./elements/StarPicker";
import TreeMap from "./charts/TreeMap";
import programElements from "../assets/program-elements";
import SubmitGem from "./elements/SubmitGem";
import {darkenedBg} from "../assets/settings";

class ProgramPicker extends React.Component {
    constructor() {
        super();
        this.state = {width: 400};
    }

    setElem(r) {
        this.elementRef = r;
        this.updateMetaData();
    }

    updateMetaData() {
        if (!this.elementRef) return;
        const {store} = this.props;
        const {treeMapStore, treeMapResultsStore} = store;
        const rect = this.elementRef.getBoundingClientRect();

        if (this.state.width === rect.width) return;
        treeMapStore.setSize(rect.width - 75, document.documentElement.clientHeight - 150);
        treeMapResultsStore.setSize(rect.width - 40, document.documentElement.clientHeight - 100);

        this.setState({'width': rect.width});
    }

    componentDidMount() {
    }

    componentDidUpdate() {
        this.updateMetaData();
    }

    render() {
        const {store, color, index, state, progress} = this.props;
        const {treeMapStore, treeMapResultsStore, interactionsStore} = store;
        const isSelected = store.selectedIndices.indexOf(index) >= 0;

        const highlightIncluded = (interactionsStore.highlightedProgramItem !== '' && store.persistStore.getScore('program', interactionsStore.highlightedProgramItem) > 0);
        const content = () => {
            if (isSelected) {
                return (<Fragment>
                    <div className={'remaining'}>What everyone said:</div>
                    <TreeMap rectangles={treeMapResultsStore.treeRectangles} highlightedId={interactionsStore.highlightedProgramItem} highlightDarken={0.8} width={treeMapResultsStore.width}
                             height={treeMapResultsStore.height} rx={15}/>
                </Fragment>);
            }
            return (<Fragment>
                <div className={'remaining'}>Remaining coins: {store.persistStore.getRemainingCoins('program')}</div>
                <div>
                    <TreeMap rectangles={treeMapStore.treeRectangles} highlightedId={(highlightIncluded) ? interactionsStore.highlightedProgramItem : ''} highlightDarken={0.5} width={treeMapStore.width}
                             height={treeMapStore.height} rx={15}/>
                </div>
                <SubmitGem gem={true} store={store} index={index} color={color}  width={200}/>
            </Fragment>);
        };
        const reportScore = (id) => {
            let score = store.persistStore.getScore('program', id);
            let average = store.resultStore.getAverageScore('program', id);
            const youScore = (score > 0) ? <Fragment> &nbsp; <b>You: {score}</b></Fragment> : '';
            let averageStr = `${Math.round(average * 10) / 10}`;
            if (averageStr.indexOf('.') < 0) averageStr += '.0';//ensure consistent width formatting

            return (
                <div className={'picked-score'}><span className={'picked-lbl'}>Average: </span>{averageStr} {youScore}
                </div>);
        };
        // console.log('PP progress: '+progress);

        return (
            <div className={'ProgramPicker'}>
                <HeightPin store={store} state={state}
                           scrollChild={<div className={'program-list'}>
                               {progress > 0.35 && progress < 1 && <div className={'remaining-coins-single-column'}>
                                   <div className={'remaining'}>Remaining coins: {store.persistStore.getRemainingCoins('program')}</div>
                               </div>}
                               <div className={'prog-elem-instructions'}>
                                   <h4>
                                       How would you invest in the campus?
                                   </h4>
                                   <p>
                                       Distribute your “coins” to show which strategies you want to invest in on campus.
                                       You have a total
                                       of {store.persistStore.getTotalCoins('program')} coins.
                                   </p>
                               </div>

                               {programElements.map((group, i) => <div key={`grp_${i}`} className={'prog-group'}>
                                   <h3>{group.name}</h3>
                                   {group.elements.map((v, i) => <div key={`prog_${v.id}`}
                                                                      style={{background: group.color}}
                                                                      className={'prog-item'} onMouseEnter={()=> interactionsStore.setHighlightedProgramItem(v.id)} onMouseLeave={()=> interactionsStore.setHighlightedProgramItem('')}>
                                       {/*{v.id === 'WC' && <input type={'text'}/>}*/}
                                       <div className={'program-text'} style={{textShadow: `${darkenedBg(group.color)} 0.15em 0.15em 0.1em`}}>{v.name}</div>
                                       {isSelected && reportScore(v.id)}
                                       {!isSelected && <StarPicker store={store} id={v.id} total={5}/>}
                                   </div>)}
                               </div>)}

                               {!isSelected && <div className={'single-column-submit'}>
                                   <SubmitGem gem={true} store={store} index={index} color={color} width={200}/>
                               </div>}
                           </div>}
                           pinChild={<div className={'tree-map'} ref={(r) => this.setElem(r)}>
                               <div className={'content'}>
                                   {content()}
                               </div>
                           </div>}
                />
            </div>
        );
    }

}

export default observer(ProgramPicker);
